import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* post(action) {
  const { vin } = action.payload;
  const url = config.api.paths.assetIotLookup;

  if (process.env.HOST !== "prod-cv") {
    yield put(actionCreators.postFailure("Skip Trace is available in production only."));
    return;
  }  

  try {
    const formData = new FormData();
    formData.append("vin", (vin || "").trim());

    const { data } = yield call(http.authorized.postForm, url, formData);
    yield put(actionCreators.postSuccess(data));
  } catch (error) {
    const message = 
      typeof error?.message === "string" && /<!DOCTYPE html/i.test(error.message)
        ? "Result not found"
        : (error?.message || "Result not found");
    logToSentry("On skip trace post:", { error });
    yield put(actionCreators.postFailure(message));
  }
}

export default function* () {
  yield all([takeLatest(actionTypes.SKIP_TRACE_POST_REQUEST, post)]);
}

//Todo: Need to refactor error handling
